// Colours
const pink =            "#FF18BD";
const pinkHover =       "#858095";
const blueDark =        "#0B002B"; // MPB
const blueDarkLighten = "#1a0066"; // MPB
const blue =            "#090a66"; // MPB
const blueHover =       "#FF8BDE";
const purple =          "#501933"; // MPB
const purple2 =         "#140d40";
const purple3 =         "#932240"; // MPB
const gold =            "#ce8e47";
const yellow =          "#f8d44c";
const tan =             "#c3ae8f";
const peach =           "#ffd394";
const white =           "#FFFFFF";

const Theme = {
  global: {
    breakpoints: {
      // Have to remove 16px because of some bug
        xsmall : { value: 576 - 16 },
        small : { value: 768 - 16 },
        medium : { value: 992 - 16 },
        large : { value: 1200 - 16 },
        xlarge : { value: 1400 -16},
    },
    colors: {
      focus: '#FF18BD',
      brand: pink,
      navLink: '#ffffff',
      navLinkHover: "#F9CF93",
      purple: '#140d40',
      blueDark: '#050507',
      blueMedium: '#140d40',
      border: '#FFFFFF',
    },
    focus: {
      shadow: {
        color: "transparent"
      }
    },
    font: {
      family: 'Inter',
      size: '16px',
      height: '20px',
    },
    drop : {
      zIndex: "30",
      //extend: {backgroundColor: "white"},
    },
    tip : {
      content: {
        "background": "white"
      },
      drop: {
        "background": "white",
      }
    },
    input: {
      font: {
        weight: "300",
        //size: "14px",
        height: "24px",
      },
    },
  },
  text : {
    font: {
      family: 'Inter',
      size: '32px',
    },
    small: {
      size: '14px',
    },
    medium: {
      size: '16px',
    },
  },
  // Buttons
  button: {
    default: {
      color: '#F9CF93', // Dark Blue
      borderWidth: '0',
      extend: `
         display: inline-block;
         padding: 10px 20px;
         min-width: 200px;
         transform: capitalize;
         font-size: 14px;
         font-family: 'SuisseBold', sans-serif;
         font-weight: 500;
         color: #140d40;
         border-width: 0;
         background: linear-gradient(90deg, rgba(208,145,76,1) 0%, rgba(228,177,74,1) 50%, rgba(247,211,76,1) 100%);

`,
    },
    primary: {
      color: '#F9CF93', // Dark blue
      borderWidth: '0',
      extend: `
        display: inline-block;
        padding: 10px 20px;
        min-width: 200px;
        text-transform: none;
        font-size: 14px;
        font-family: 'SuisseBold', sans-serif;
        font-weight: 500;
        color: #140d40;
        border-width: 0;
        background: radial-gradient(50% 50% at 50% 50%, #FF79BC 0%, #FF0AAC 100%);
      `,
    },
    secondary: {
      color: '#ce8e47', // Dark Blue
      borderWidth: '0',
      minWidth: '200px',
      extend: `
        display: inline-block;
        padding: 10px 20px;
        min-width: 200px;
        text-transform: none;
        font-size: 14px;
        font-family: 'SuisseBold', sans-serif;
        font-weight: 500;
        color: #fff;
        border-width: 0;
        background-color: #0B002B;
        /* We use a gradient of the same color to prevent the "image-to-color" flash */
        background: radial-gradient(circle, #0B002B 0%, #0B002B 100%);
        transition: background 0.3s ease-in-out;
      `,
    },
    font: {
      family: 'Inter',
      size: '32px',
    },
    hover: {
      primary: {
        extend: `
          color: #FFF;
          background: ${blueHover};
          /* We use a gradient of the same color to prevent the "image-to-color" flash */
          background: radial-gradient(circle, ${blueHover} 0%, ${blueHover} 100%);
        `,
      },
      secondary: {
        extend: `
          color: ${blueDark};
          background-color: ${pinkHover};
          background: var(--Gradient-Pink, radial-gradient(50% 50% at 50% 50%, ${pinkHover} 0%, ${pinkHover} 100%));
          transition: background-color 0.3s ease-in-out;
        `,
      }
    }
  },
  // Forms
  formField : {
    content: {
      margin: {
        bottom: "15px"
      }
    }
  },
  // Accordion
  accordion : {
    hover : {
      heading : {
        color: "#F9CF93"
      }
    }
  },
  // Layer
  layer : {
    background: "transparent",
    overlay: {
      background: "rgba(0, 0, 0, 0.5)"
    }
  },
  // checkbox
  checkBox : {
    border: {
      color: "#FFFFFF"
    },
    hover: {
      border: {
        color: "#FFFFFF"
      }
    },
    toggle: {
        // background: undefined
        color: {
          dark: pink,
          light: pink
        },
        knob: {
          // extend: undefined,
        },
    }
  },
  // select
  select: {
    options: {
      font: {
          weight: 700
      },
      container: {
        background: white,
        styles: {
          zIndex: "201"
        }
      }
    }
  },
  options: {
    container: {
      align: 'start',
      pad: 'small'
    },
    text: {
      margin: 'none'
    }
  },
};

export default Theme;
